<template>
  <div :class="['tmallBox', { inApp: $root.$data.isApp }]">
    <common-title titleName="激活中心" :bcColor="'none'" :zIndex="1000"></common-title>
    <MemberActive />
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import MemberActive from './component/memberActive.vue';

export default {
  components: {
    CommonTitle,
    MemberActive,
  },
  data() {
    return {
     
    };
  },

  computed: {},
  mounted() {},

  methods: {
  },
};
</script>

<style lang="scss" scoped>
.tmallBox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  min-height: 100vh;
  padding-top: 120px;
  padding-bottom: 100px;
  background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-upgrade-mini/home/tmall-bg.png') no-repeat;
  background-size: 100%;
  &.inApp {
    padding-top: 80px;
    padding-bottom: 0;
  }

  ::v-deep .commonTitle {
    .titleName {
      color: #000;
      font-size: 31px;
    }
    .backButton {
      width: 44px;
      height: 48px;
      background: url('https://iqh-zt.oss-cn-beijing.aliyuncs.com/college-mini/courseTmall-back.png')
        no-repeat;
      background-size: 100%;
    }
  }
  
}
</style>
